export default function (dom, opts) {

	function init() {
		const slider = dom.querySelector("#slider");
		const sliderItems = dom.querySelectorAll(".slider-item");
		const itemCount = sliderItems.length;

		if (!slider || itemCount === 0) {
			return;
		}

		let currentIndex = 0;
		let visibleCount = getVisibleCount();


		swipedetect(slider, function(swipedir){
			if (swipedir === "left")  {
				slideRight();
			}
			if (swipedir === "right") {
				slideLeft();
			}
		});


		const arrowLeft = dom.querySelector("#arrowLeft");
		const arrowRight = dom.querySelector("#arrowRight");

		if (arrowLeft) arrowLeft.addEventListener("click", slideLeft);
		if (arrowRight) arrowRight.addEventListener("click", slideRight);


		window.addEventListener("resize", onResize);

		updateSliderPosition();


		function getVisibleCount() {
			return window.matchMedia("(min-width: 768px)").matches ? 3 : 1;
		}

		function onResize() {
			visibleCount = getVisibleCount();

			const maxIndex = Math.max(itemCount - visibleCount, 0);
			if (currentIndex > maxIndex) {
				currentIndex = maxIndex;
			}

			updateSliderPosition();
		}

		function swipedetect(el, callback){
			let startX,
				startY,
				distX,
				distY,
				startTime;

			const threshold = 50;
			const restraint = 100;
			const allowedTime = 400;
			const handleswipe = callback || function(){};

			el.addEventListener("touchstart", function(e){
				const touchobj = e.changedTouches[0];
				startX = touchobj.pageX;
				startY = touchobj.pageY;
				startTime = new Date().getTime();
			}, false);

			el.addEventListener("touchend", function(e){
				const touchobj = e.changedTouches[0];
				distX = touchobj.pageX - startX;
				distY = touchobj.pageY - startY;
				const elapsedTime = new Date().getTime() - startTime;

				let swipedir = "none";

				if (elapsedTime <= allowedTime){
					if (Math.abs(distX) >= threshold && Math.abs(distY) <= restraint){
						swipedir = (distX < 0) ? "left" : "right";
					}
				}
				handleswipe(swipedir);
			}, false);
		}

		function getItemWidth() {
			const first = sliderItems[0];
			if (!first) return 0;

			const style = window.getComputedStyle(first);
			const marginLeft = parseFloat(style.marginLeft) || 0;
			const marginRight = parseFloat(style.marginRight) || 0;
			return first.clientWidth + marginLeft + marginRight;
		}

		function updateSliderPosition() {
			const itemWidth = getItemWidth();
			if (itemWidth === 0) return;
			slider.style.transform = `translateX(-${currentIndex * itemWidth}px)`;
		}

		function slideLeft() {
			if (currentIndex === 0) {
				currentIndex = Math.max(itemCount - visibleCount, 0);
			} else {
				currentIndex = currentIndex - 1;
			}
			updateSliderPosition();
		}

		function slideRight() {
			const maxIndex = Math.max(itemCount - visibleCount, 0);

			if (currentIndex === maxIndex) {
				currentIndex = 0;
			} else {
				currentIndex = currentIndex + 1;
			}
			updateSliderPosition();
		}
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
}
